import { QueryFactory } from "../../../../Common";
export const QOptIn = QueryFactory("OptIn");
//# sourceMappingURL=QOptIn.js.map